<template>
    <v-form>

        <v-container v-if="client">
            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-domain</v-icon>
                            {{ $t('views.main.profile.profile.store_data') }}
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.client_name_label')"
                                        v-model="clientForm.ClientName"
                                        :counter="50"
                                        maxlength="50"
                                        :error="$store.getters.hasValidationError('ClientName')"
                                        :error-messages="$store.getters.validationError('ClientName')"
                                        readonly
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.street_label')"
                                        v-model="clientForm.Street"
                                        :counter="40"
                                        maxlength="40"
                                        :error="$store.getters.hasValidationError('Street')"
                                        :error-messages="$store.getters.validationError('Street')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.postal_code_label')"
                                        v-model="clientForm.PostalCode"
                                        :counter="6"
                                        maxlength="6"
                                        :error="$store.getters.hasValidationError('PostalCode')"
                                        :error-messages="$store.getters.validationError('PostalCode')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-autocomplete
                                        :label="$t('views.main.profile.profile.city_label')"
                                        v-model="clientForm.CityID"
                                        :items="cities"
                                        item-text="CityName"
                                        item-value="CityID"
                                        :loading="cityIndexing"
                                        :disabled="!cities.length"
                                        :error="$store.getters.hasValidationError('CityID')"
                                        :error-messages="$store.getters.validationError('CityID')"
                                        clearable
                                    ></v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-select
                                        :label="$t('views.main.profile.profile.providence_label')"
                                        v-model="clientForm.ProvidenceID"
                                        :items="providences"
                                        item-text="ProvidenceName"
                                        item-value="ProvidenceID"
                                        :loading="providenceIndexing"
                                        :disabled="!providences.length"
                                        :error="$store.getters.hasValidationError('ProvidenceID')"
                                        :error-messages="$store.getters.validationError('ProvidenceID')"
                                        clearable
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-select
                                        :label="$t('views.main.profile.profile.country_label')"
                                        v-model="clientForm.CountryID"
                                        :items="countries"
                                        item-text="CountryName"
                                        item-value="CountryID"
                                        :loading="countryIndexing"
                                        :disabled="!countries.length"
                                        :error="$store.getters.hasValidationError('CountryID')"
                                        :error-messages="$store.getters.validationError('CountryID')"
                                        clearable
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.tin_label')"
                                        v-model="clientForm.NIP"
                                        :counter="10"
                                        maxlength="10"
                                        :error="$store.getters.hasValidationError('NIP')"
                                        :error-messages="$store.getters.validationError('NIP')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.regon_label')"
                                        v-model="clientForm.REGON"
                                        :counter="9"
                                        maxlength="9"
                                        :error="$store.getters.hasValidationError('REGON')"
                                        :error-messages="$store.getters.validationError('REGON')"
                                    ></v-text-field>
                                </v-col>

                                <v-col class="text-right">
                                    <v-btn
                                        color="success"
                                        text
                                        rounded
                                        @click="clientUpdate"
                                        :loading="clientUpdating"
                                    >{{ $t('views.main.profile.profile.save_button') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-face-agent</v-icon>
                            {{ $t('views.main.profile.profile.contact_data') }}
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.contact_name_label')"
                                        v-model="clientDetailForm.ContactName"
                                        :counter="50"
                                        maxlength="50"
                                        :error="$store.getters.hasValidationError('ContactName')"
                                        :error-messages="$store.getters.validationError('ContactName')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.phone_label')"
                                        v-model="clientDetailForm.Phone"
                                        :counter="20"
                                        maxlength="20"
                                        :error="$store.getters.hasValidationError('Phone')"
                                        :error-messages="$store.getters.validationError('Phone')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.fax_label')"
                                        v-model="clientDetailForm.Fax"
                                        :counter="20"
                                        maxlength="20"
                                        :error="$store.getters.hasValidationError('Fax')"
                                        :error-messages="$store.getters.validationError('Fax')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.email_label')"
                                        v-model="clientDetailForm.Email"
                                        :counter="50"
                                        maxlength="50"
                                        :error="$store.getters.hasValidationError('Email')"
                                        :error-messages="$store.getters.validationError('Email')"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.www_label')"
                                        v-model="clientDetailForm.WWW"
                                        :counter="100"
                                        maxlength="100"
                                        :error="$store.getters.hasValidationError('WWW')"
                                        :error-messages="$store.getters.validationError('WWW')"
                                    ></v-text-field>
                                </v-col>

                                <v-col class="text-right">
                                    <v-btn
                                        color="success"
                                        text
                                        rounded
                                        @click="clientDetailUpdate"
                                        :loading="clientDetailUpdating"
                                    >{{ $t('views.main.profile.profile.save_button') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-account-outline</v-icon>
                            {{ $t('views.main.profile.profile.login_change') }}
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.login_label')"
                                        disabled
                                        :value="client.WebAppUser.email"
                                    ></v-text-field>

                                    <v-icon class="mr-2" color="info">mdi-information-outline</v-icon>
                                    {{ $t('views.main.profile.profile.login_change_information') }}
                                    <strong>biuro@jarstol.eu</strong>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-key-variant</v-icon>
                            {{ $t('views.main.profile.profile.password_change') }}
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.current_password_label')"
                                        v-model="clientPasswordForm.current_password"
                                        :append-icon="currentPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="currentPasswordVisible ? 'text' : 'password'"
                                        @click:append="currentPasswordVisible = !currentPasswordVisible"
                                        :counter="128"
                                        maxlength="128"
                                        :error="$store.getters.hasValidationError('current_password')"
                                        :error-messages="$store.getters.validationError('current_password')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.new_password_label')"
                                        v-model="clientPasswordForm.password"
                                        :append-icon="newPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="newPasswordVisible ? 'text' : 'password'"
                                        @click:append="newPasswordVisible = !newPasswordVisible"
                                        :counter="128"
                                        maxlength="128"
                                        :error="$store.getters.hasValidationError('password')"
                                        :error-messages="$store.getters.validationError('password')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('views.main.profile.profile.confirm_new_password_label')"
                                        v-model="clientPasswordForm.password_confirmation"
                                        :append-icon="newPasswordConfirmationVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="newPasswordConfirmationVisible ? 'text' : 'password'"
                                        @click:append="newPasswordConfirmationVisible = !newPasswordConfirmationVisible"
                                        :counter="128"
                                        maxlength="128"
                                        :error="$store.getters.hasValidationError('password_confirmation')"
                                        :error-messages="$store.getters.validationError('password_confirmation')"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="text-right">
                                    <v-btn
                                        color="success"
                                        text
                                        rounded
                                        @click="clientPasswordUpdate"
                                        :loading="clientPasswordUpdating"
                                    >{{ $t('views.main.profile.profile.save_button') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

    </v-form>
</template>

<script>
    export default {
        name: "Profile",

        data() {
            return {
                currentPasswordVisible: false,
                newPasswordVisible: false,
                newPasswordConfirmationVisible: false,

                countries: [],
                countryIndexing: false,
                providences: [],
                providenceIndexing: false,
                cities: [],
                cityIndexing: false,

                client: null,
                clientShowing: false,

                clientUpdating:false,
                clientDetailUpdating:false,
                clientPasswordUpdating:false,

                clientForm: {
                    ClientName: null,
                    CityID: null,
                    ProvidenceID: null,
                    CountryID: null,
                    PostalCode: null,
                    Street: null,
                    NIP: null,
                    REGON: null
                },
                clientDetailForm: {
                    ContactName: null,
                    Phone: null,
                    Fax: null,
                    WWW: null,
                    Email: null
                },
                clientPasswordForm: {
                    current_password: null,
                    password: null,
                    password_confirmation: null,
                },
            };
        },

        methods: {
            countryIndex: function () {
                this.countryIndexing = true;

                this.$store.dispatch('countryIndex').then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.loading_countries_failed')
                        );
                        return;
                    }

                    this.countries = response.data.data;
                })
                    .catch(() => {})
                    .then(() => {
                        this.countryIndexing = false;
                    });
            },
            providenceIndex: function () {
                this.providenceIndexing = true;

                this.$store.dispatch('providenceIndex').then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.loading_providences_failed')
                        );
                        return;
                    }

                    this.providences = response.data.data;
                })
                    .catch(() => {})
                    .then(() => {
                        this.providenceIndexing = false;
                    });
            },
            cityIndex: function () {
                this.cityIndexing = true;

                this.$store.dispatch('cityIndex').then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.loading_cities_failed')
                        );
                        return;
                    }

                    this.cities = response.data.data;
                })
                    .catch(() => {})
                    .then(() => {
                        this.cityIndexing = false;
                    });
            },
            clientShow: function () {
                this.clientShowing = true;

                this.$store.dispatch('clientShow').then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.loading_profile_failed')
                        );
                        return;
                    }

                    this.client = response.data.data;
                })
                    .catch(() => {})
                    .then(() => {
                        this.clientShowing = false;
                    });
            },
            clientUpdate: function () {
                this.$store.commit("resetValidation");

                this.clientUpdating = true;

                this.$store.dispatch('clientUpdate', this.clientForm).then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.profile_update_failed')
                        );
                        return;
                    }

                    this.$store.commit(
                        "showSnackbarSuccess",
                        this.$t('views.main.profile.profile.profile_updated')
                    );
                })
                    .catch(() => {})
                    .then(() => {
                        this.clientUpdating = false;
                    });
            },
            clientDetailUpdate: function () {
                this.$store.commit("resetValidation");

                this.clientDetailUpdating = true;

                this.$store.dispatch('clientDetailUpdate', this.clientDetailForm).then(response => {
                    if (response.status !== 200) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.profile_update_failed')
                        );
                        return;
                    }

                    this.$store.commit(
                        "showSnackbarSuccess",
                        this.$t('views.main.profile.profile.profile_updated')
                    );
                })
                    .catch(() => {})
                    .then(() => {
                        this.clientDetailUpdating = false;
                    });
            },
            clientPasswordUpdate: function () {
                this.$store.commit("resetValidation");

                this.clientPasswordUpdating = true;

                this.$store.dispatch('clientPasswordUpdate', this.clientPasswordForm).then(response => {
                    if (response.status !== 204) {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.profile.profile.password_change_failed')
                        );
                        return;
                    }

                    this.resetClientPasswordForm();
                    this.$store.commit(
                        "showSnackbarSuccess",
                        this.$t('views.main.profile.profile.password_changed')
                    );
                })
                    .catch(() => {})
                    .then(() => {
                        this.clientPasswordUpdating = false;
                    });
            },
            resetClientPasswordForm: function () {
                for(const index in this.clientPasswordForm) {
                    this.clientPasswordForm[index] = null;
                }
            },
        },

        created () {
            this.countryIndex();
            this.providenceIndex();
            this.cityIndex();
            this.clientShow();
        },

        watch: {
            client: function (client) {
                for(const index in this.clientForm) {
                    this.clientForm[index] = client[index];
                }
                for(const index in this.clientDetailForm) {
                    this.clientDetailForm[index] = client.ClientDetail[index];
                }
            },
        },
    }
</script>

<style scoped>

</style>
